import { isValidPhoneNumber } from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/metadata.min.json';
import { trim } from 'lodash';
import { mixed, object, ref, string } from 'yup';

import { Gender } from '../../../../../data/types/api/graphql';
import { isValidBirthDate } from '../../../../../data/utils/date.utils';
import { messages, regExEmail } from '../../../../../data/utils/form.utils';
import { FileItemData } from '../../../../../data/utils/upload.utils';

export const schemas = {
  default: object()
    .shape({
      firstName: string()
        .transform(trim)
        .required(messages.required.id)
        .default(''),
      lastName: string()
        .transform(trim)
        .required(messages.required.id)
        .default(''),
      email: string()
        .transform(trim)
        .email(messages.invalidEmail.id)
        .matches(regExEmail, messages.invalidRegEx.id)
        .required(messages.required.id)
        .default(''),
      gender: mixed<Gender>()
        .oneOf(Object.values(Gender))
        .required(messages.required.id),
      birthDate: string()
        .transform(trim)
        .test('max-date', messages.invalidDate.id, value =>
          isValidBirthDate(value ?? '')
        )
        .required(messages.required.id)
        .default('')
        .nullable(),
      phoneNumber: string()
        .transform(trim)
        .test('international-phone', messages.invalidPhone.id, value =>
          value ? isValidPhoneNumber(value, metadata) === true : false
        )
        .required(messages.required.id)
        .default(''),
      avatar: mixed<FileItemData>().default(null).nullable(),
    })
    .required()
    .noUnknown(),
  password: object()
    .shape({
      currentPassword: string()
        .transform(trim)
        .required(messages.required.id)
        .default(''),
      newPassword: string()
        .transform(trim)
        .matches(
          /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z.><!#$@^%&? _-])[a-zA-Z0-9.><!#$@^%&? _-]{8,100}$/,
          messages.invalidPassword.id
        )
        .default('')
        .required(messages.required.id),
      repeatNewPassword: string()
        .transform(trim)
        .matches(
          /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z.><!#$@^%&? _-])[a-zA-Z0-9.><!#$@^%&? _-]{8,100}$/,
          messages.invalidPassword.id
        )
        .default('')
        .oneOf([ref('newPassword')], messages.invalidNotMatching.id)
        .required(messages.required.id),
    })
    .required()
    .noUnknown(),
  pincode: object()
    .shape({
      currentPinCode: string()
        .transform(trim)
        .required(messages.required.id)
        .matches(/^[0-9]+$/, messages.invalidRegEx.id)
        .min(5, messages.minLength.id)
        .max(5, messages.maxLength.id)
        .default('')
        .nullable(),
      newPinCode: string()
        .transform(trim)
        .required(messages.required.id)
        .matches(/^[0-9]+$/, messages.invalidRegEx.id)
        .min(5, messages.minLength.id)
        .max(5, messages.maxLength.id)
        .default('')
        .nullable(),
      repeatNewPinCode: string()
        .transform(trim)
        .required(messages.required.id)
        .matches(/^[0-9]+$/, messages.invalidRegEx.id)
        .default('')
        .oneOf([ref('newPinCode')], messages.invalidNotMatching.id)
        .min(5, messages.minLength.id)
        .max(5, messages.maxLength.id)
        .nullable(),
    })
    .required()
    .noUnknown(),
};
